import { Components, Theme } from '@mui/material/styles';

const listTheme: Components<Theme>['MuiList'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.nav-menu': {
        '& .MuiListItem-root': {
          background: theme.palette.neutralWhite,
          '&.header': {
            flexDirection: 'column',
            borderBottom: `2px solid ${theme.palette.grey[100]}`,
            background: theme.palette.grey[100],
          },
          '& .MuiTypography-root': {
            color: theme.palette.corporateBlue,
            fontFamily: theme.typography.fontFamily,
            '&.topListItem': {
              marginBottom: theme.spacing(1)
            }
          },
          '& .MuiButtonBase-root': {
            '&:hover': {
              background: theme.palette.warmBlue,
              color: theme.palette.neutralWhite
            },
            '&.selected': {
              background: theme.palette.warmBlue,
              color: theme.palette.neutralWhite,
            },

            '&.Mui-disabled': {
              opacity: 1,
              '& .MuiTypography-root': {
                color: theme.palette.grey.A100,
              },
              '& .menu-icon': {
                fill: theme.palette.grey.A100
              }
            },
            '& .MuiSvgIcon-root': {
              fill: theme.palette.corporateBlue,
              '&.disabled': {
                fill: theme.palette.grey.A100,
              }
            }
          }
        }
      }
    })
  }
};

export default listTheme;
